import { Injectable } from '@angular/core';
import { Observable, delay, of } from 'rxjs';

export interface CertificateIssuancePayload {
    courseId: string;
    students: {
        studentId: string;
        certificateType: 'completion' | 'participation' | 'no-participation';
    }[];
}

@Injectable({
    providedIn: 'root',
})
export class CertificateService {
    issueCertificates(payload: CertificateIssuancePayload): Observable<any> {
        // Dummy API call - replace with actual API endpoint
        return of({ success: true }).pipe(delay(2000)); // Simulate API delay
    }
}
